const initServer = () => {
  const env = process.env.NODE_ENV
  let server
  switch (env) {
    case 'development':
      server = 'http://localhost:4000'
      break
    case 'earlybird':
      server = 'https://t.api.mcms.fofinvesting.com'
      break
    case 'production':
      server = 'https://api.mcms.fofinvesting.com'
      break
    default:
      console.error('没有指定运行环境，退出程序。')
      process.exit()
  }
  return server
}

module.exports = {
  initServer
}
